import { useLayoutEffect, useMemo } from 'react';

import { NumberParam, useQueryParams, withDefault } from 'use-query-params';

import usePageableCollection, { ERowsPerPageOptions } from '../usePageableCollection';

export default function usePageableCollectionSearchParams(ns?: string) {
  const [{ limit, page }, updatePageableQuery] = useQueryParams({
    limit: withDefault({ ...NumberParam, urlName: ns ? `${ns}Limit` : undefined }, ERowsPerPageOptions.S),
    page: withDefault({ ...NumberParam, urlName: ns ? `${ns}Page` : undefined }, 1),
  });

  const { rowsPerPageOptions, currentPage, onPageSizeChange, pageSize, onPageChange } = usePageableCollection({
    pageSize: limit as ERowsPerPageOptions,
    currentPage: page - 1,
  });

  useLayoutEffect(() => updatePageableQuery((prevState) => ({ ...prevState, page: currentPage + 1 })), [currentPage, updatePageableQuery]);
  useLayoutEffect(() => updatePageableQuery((prevState) => ({ ...prevState, limit: pageSize })), [pageSize, updatePageableQuery]);

  return useMemo(
    () => ({
      searchParams: {
        limit,
        page,
      },
      rowsPerPageOptions,
      onPageSizeChange,
      onPageChange,
    }),
    [limit, page, onPageSizeChange, onPageChange, rowsPerPageOptions],
  );
}
